import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/billing_rule_temperature_timers',
  component: Management,
  redirect: '/billing_rule_temperature_timers/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/billing_rule_temperature_timers/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listBillingRuleTemperatureTimers
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/billing_rule_temperature_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTemperatureTimers,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/billing_rule_temperature_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTemperatureTimers,
            tabName: 'pending'
          }
        },
        {
          path: 'active',
          component: () => import('@/views/billing_rule_temperature_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTemperatureTimers,
            tabName: 'active'
          }
        },
        {
          path: 'invalid',
          component: () => import('@/views/billing_rule_temperature_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTemperatureTimers,
            tabName: 'invalid'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/billing_rule_temperature_timers/New'),
      meta: {
        auth: Auth.createBillingRuleTemperatureTimer
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/billing_rule_temperature_timers/Edit'),
      meta: {
        auth: Auth.updateBillingRuleTemperatureTimer
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/billing_rule_temperature_timers/DetailLayout'),
      meta: {
        auth: Auth.showBillingRuleTemperatureTimer
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/billing_rule_temperature_timers/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showBillingRuleTemperatureTimer
          }
        },
        // 执行记录
        {
          path: 'execution_records',
          component: () => import('@/views/billing_rule_temperature_timers/details/ExecutionRecords'),
          meta: {
            tabName: 'execution_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showBillingRuleTemperatureTimer
          }
        }
      ]
    }
  ]
}
